<template>
	<div>
		<Header :sel='type' @changePhone="changePhone" />
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
			
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner04.png" >
				<div class="nybt">
					<h3>业务范围</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="">业务范围</a> > {{title}}
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
					<div class="page-wrap-left xymob-menu-click visible-xs visible-sm">
						<div class="xymob-left-close-btn"><i class="icon-font icon-close"></i></div>
						<div class="xypg-left">
							<!-- * 分类 * -->
							
			
						
			
							
							
						</div>
					</div>
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-right-content">
						
								<!-- 产品列表页 -->
								<ul class="xypg-product-list clearfix">
									<li v-for="item in actList" @click="goBusDetail(item.categoryCode, item.categoryName)">
										<a href="javascript:void(0)" class="img"><img
												:src="item.cover" /></a>
										<h3><a href="javascript:void(0)">{{item.categoryName}}</a></h3>
									</li>
								</ul>
							</div>
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>
			
			<Footer></Footer>

		</div>


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		categorysortPage,
		articleList,
		articleDetail
	} from '@/api/reqFetch.js'
	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				tabList: [],
				selName: '',
				selid: '0',
				list: [],
				pageNum: 1,
				indexs: [],
				totalPage: 0,
				showPhone: false,
				type: '',
				categoryCode: '',
				configList: [],
				selOneName: '',
				title: '',
				total: 0,
				level: 1,
				firstCategoryCode: '',
				pos: '',
				xhDetail: {},
				id: '',
				type:'',
				title:'',
				actList:[]
			}
		},

		mounted() {
			this.type = this.$route.query.type
			this.title = this.$route.query.title
			this.getCategorysortPage()
		},

		methods: {
			goBusDetail(type,title){
				let url='/businessDetail?type='+type+'&title='+title
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '业务范围') {
							item.children.map(items=>{
								if (items.categoryName == this.title) {
									this.actList = items.children
									this.actList.sort((a, b) => a.orderNum - b.orderNum);
								}
							})
							
						}
					})
			
				});
			},
			
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			
			checkIndex() {
				var left = 1;
				var right = this.totalPage;
				var ar = [];
				if (this.totalPage >= 10) {
					if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
						left = this.pageNum - 1
						right = this.pageNum + 1
					} else {
						if (this.pageNum <= 1) {
							left = 1
							right = 10
						} else {
							right = this.totalPage
							left = this.totalPage - 2
						}
					}
				}
				while (left <= right) {
					ar.push(left)
					left++
				}
				this.indexs = ar

			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},
			changePhone(val) {
				this.showPhone = val
			},
			goPage(type) {
				if (type == 'home') {
					this.pageNum = 1
				} else if (type == 'end') {
					this.pageNum = Number(this.totalPage)

				} else if (type == 'last') {
					if (this.pageNum > 1) {
						this.pageNum = this.pageNum - 1
					}
				} else if (type == 'next') {
					if (this.pageNum < (this.totalPage)) {
						this.pageNum = this.pageNum + 1
					}
				} else {
					this.pageNum = type
				}
				this.getData()
			},
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: 12,
					memberType: this.memberType,
				}
				memberPageList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
					this.totalPage = Math.ceil(res.total / 12)
					this.checkIndex();
					
				});
			},
			
		}
	}
</script>

<style scoped>
	.logo-img {
		width: 180px;
		height: 55px;
		flex-shrink: 0
	}
</style>